import { MapMarkerOffIcon } from './MapMarkerOffIcon';

/**
 * author: Austin Andrews
 * id 92410469-09D9-4C29-AC79-CD0DF882D05F
 * name map-marker-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-off.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationOffIcon = MapMarkerOffIcon;
export default LocationOffIcon